import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import { IconProps, SvgIcon } from './SvgIcon';

const useStyles = makeStyles(() => ({
  spinner: {
    animation: `$rotate 1.5s linear infinite`,
  },
  '@keyframes rotate': {
    to: {
      transform: 'rotate(360deg)',
    },
  },

  '@media only percy': {
    spinner: {
      display: 'none',
    },
  },
}));

export function Spinner(props: IconProps): JSX.Element {
  const classes = useStyles();
  const { ...rest } = props;

  return (
    <SvgIcon
      {...rest}
      className={classes.spinner}
      name="Spinner"
      stroke
      viewBox="0 0 96 96"
    >
      <path
        fill="currentColor"
        style={{ opacity: 0.3 }}
        d="M48,94C22.6,94,2,73.4,2,48S22.6,2,48,2s46,20.6,46,46S73.4,94,48,94z M48,6
                        C24.8,6,6,24.8,6,48c0,23.2,18.8,42,42,42c23.2,0,42-18.8,42-42C90,24.8,71.2,6,48,6z"
      />
      <path
        fill="currentColor"
        d="M6,48H2C2,22.6,22.6,2,48,2v4C24.8,6,6,24.8,6,48z"
      />
    </SvgIcon>
  );
}
